import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { TimerIcon } from 'lucide-react';
export function StickyTopBar() {
  const {
    formattedTime
  } = useCountdown();
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-red text-white py-2 px-4 shadow-md" data-id="element-171">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base font-medium" data-id="element-172">
        <TimerIcon className="w-5 h-5 animate-pulse" data-id="element-173" />
        <span data-id="element-174">Esta oferta termina pronto:</span>
        <span className="font-bold tracking-wider bg-black/20 px-2 py-0.5 rounded" data-id="element-175">
          {formattedTime}
        </span>
      </div>
    </div>;
}